"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AddAndSortArray", {
  enumerable: true,
  get: function get() {
    return _arrayHelpers.AddAndSortArray;
  }
});
Object.defineProperty(exports, "BinaryFindInArray", {
  enumerable: true,
  get: function get() {
    return _arrayHelpers.BinaryFindInArray;
  }
});
Object.defineProperty(exports, "Capitalize", {
  enumerable: true,
  get: function get() {
    return _stringHelpers.Capitalize;
  }
});
Object.defineProperty(exports, "CapitalizeFirstLetter", {
  enumerable: true,
  get: function get() {
    return _stringHelpers.CapitalizeFirstLetter;
  }
});
Object.defineProperty(exports, "CreateCompareValueOverride", {
  enumerable: true,
  get: function get() {
    return _objectHelpers.CreateCompareValueOverride;
  }
});
Object.defineProperty(exports, "DateToDateAndTimeFormat", {
  enumerable: true,
  get: function get() {
    return _dateHelpers.DateToDateAndTimeFormat;
  }
});
Object.defineProperty(exports, "DateToShortIsoString", {
  enumerable: true,
  get: function get() {
    return _dateHelpers.DateToShortIsoString;
  }
});
Object.defineProperty(exports, "DateToShortReadableDate", {
  enumerable: true,
  get: function get() {
    return _dateHelpers.DateToShortReadableDate;
  }
});
Object.defineProperty(exports, "DeepMergeObjects", {
  enumerable: true,
  get: function get() {
    return _objectHelpers.DeepMergeObjects;
  }
});
Object.defineProperty(exports, "ExtractNamePieces", {
  enumerable: true,
  get: function get() {
    return _dataHelpers.ExtractNamePieces;
  }
});
Object.defineProperty(exports, "FormatAsCurrency", {
  enumerable: true,
  get: function get() {
    return _formatters.FormatAsCurrencyForLocale;
  }
});
Object.defineProperty(exports, "FormatAsCurrencyForLocale", {
  enumerable: true,
  get: function get() {
    return _formatters.FormatAsCurrencyForLocale;
  }
});
Object.defineProperty(exports, "FormatDigitalTime", {
  enumerable: true,
  get: function get() {
    return _numberHelpers.FormatDigitalTime;
  }
});
Object.defineProperty(exports, "FormatNumberForLocale", {
  enumerable: true,
  get: function get() {
    return _formatters.FormatNumberForLocale;
  }
});
Object.defineProperty(exports, "FormatNumberToMinDigits", {
  enumerable: true,
  get: function get() {
    return _numberHelpers.FormatNumberToMinDigits;
  }
});
Object.defineProperty(exports, "FormatOwnerName", {
  enumerable: true,
  get: function get() {
    return _formatters.FormatOwnerName;
  }
});
Object.defineProperty(exports, "GetAgeInWeeks", {
  enumerable: true,
  get: function get() {
    return _ageHelpers.GetAgeInWeeks;
  }
});
Object.defineProperty(exports, "GetAgeInYears", {
  enumerable: true,
  get: function get() {
    return _ageHelpers.GetAgeInYears;
  }
});
Object.defineProperty(exports, "GetItemIndexWithinArray", {
  enumerable: true,
  get: function get() {
    return _arrayHelpers.GetItemIndexWithinArray;
  }
});
Object.defineProperty(exports, "GetMaxAge", {
  enumerable: true,
  get: function get() {
    return _ageHelpers.GetMaxAge;
  }
});
Object.defineProperty(exports, "GetMinAge", {
  enumerable: true,
  get: function get() {
    return _ageHelpers.GetMinAge;
  }
});
Object.defineProperty(exports, "GetMinAndMaxAges", {
  enumerable: true,
  get: function get() {
    return _ageHelpers.GetMinAndMaxAges;
  }
});
Object.defineProperty(exports, "GetMostOccurringBoolean", {
  enumerable: true,
  get: function get() {
    return _arrayHelpers.GetMostOccurringBoolean;
  }
});
Object.defineProperty(exports, "GetRandomBetweenExclusive", {
  enumerable: true,
  get: function get() {
    return _numberHelpers.GetRandomBetweenExclusive;
  }
});
Object.defineProperty(exports, "GetRandomBetweenInclusive", {
  enumerable: true,
  get: function get() {
    return _numberHelpers.GetRandomBetweenInclusive;
  }
});
Object.defineProperty(exports, "GetRandomItemFromArray", {
  enumerable: true,
  get: function get() {
    return _arrayHelpers.GetRandomItemFromArray;
  }
});
Object.defineProperty(exports, "GetRandomNumberBelow", {
  enumerable: true,
  get: function get() {
    return _numberHelpers.GetRandomNumberBelow;
  }
});
Object.defineProperty(exports, "GetRoundedMedian", {
  enumerable: true,
  get: function get() {
    return _arrayHelpers.GetRoundedMedian;
  }
});
Object.defineProperty(exports, "HashCode", {
  enumerable: true,
  get: function get() {
    return _numberHelpers.HashCode;
  }
});
Object.defineProperty(exports, "IsAnObject", {
  enumerable: true,
  get: function get() {
    return _objectHelpers.IsAnObject;
  }
});
Object.defineProperty(exports, "IsDateEntryComplete", {
  enumerable: true,
  get: function get() {
    return _ageHelpers.IsDateEntryComplete;
  }
});
Object.defineProperty(exports, "IsValidDate", {
  enumerable: true,
  get: function get() {
    return _dateHelpers.IsValidDate;
  }
});
Object.defineProperty(exports, "LowerCaseFirstLetter", {
  enumerable: true,
  get: function get() {
    return _stringHelpers.LowerCaseFirstLetter;
  }
});
Object.defineProperty(exports, "MakeInheritanceObject", {
  enumerable: true,
  get: function get() {
    return _objectHelpers.MakeInheritanceObject;
  }
});
Object.defineProperty(exports, "MoveItemInArrayCopy", {
  enumerable: true,
  get: function get() {
    return _arrayHelpers.MoveItemInArrayCopy;
  }
});
Object.defineProperty(exports, "MoveItemInArrayMutate", {
  enumerable: true,
  get: function get() {
    return _arrayHelpers.MoveItemInArrayMutate;
  }
});
Object.defineProperty(exports, "ObjectsAreTheSame", {
  enumerable: true,
  get: function get() {
    return _objectHelpers.ObjectsAreTheSame;
  }
});
Object.defineProperty(exports, "OverrideMergeObjects", {
  enumerable: true,
  get: function get() {
    return _objectHelpers.OverrideMergeObjects;
  }
});
Object.defineProperty(exports, "RichTextParser", {
  enumerable: true,
  get: function get() {
    return _stringHelpers.RichTextParser;
  }
});
Object.defineProperty(exports, "RoundCurrency", {
  enumerable: true,
  get: function get() {
    return _currencyHelpers.RoundCurrency;
  }
});
Object.defineProperty(exports, "RoundToDecimal", {
  enumerable: true,
  get: function get() {
    return _numberHelpers.RoundToDecimal;
  }
});
Object.defineProperty(exports, "TimeStampToShortReadableDate", {
  enumerable: true,
  get: function get() {
    return _dateHelpers.TimeStampToShortReadableDate;
  }
});
Object.defineProperty(exports, "TransformPlacesData", {
  enumerable: true,
  get: function get() {
    return _dataHelpers.TransformPlacesData;
  }
});
Object.defineProperty(exports, "UpdateNestedProperty", {
  enumerable: true,
  get: function get() {
    return _objectHelpers.UpdateNestedProperty;
  }
});
Object.defineProperty(exports, "UseAnInsteadOfA", {
  enumerable: true,
  get: function get() {
    return _stringHelpers.UseAnInsteadOfA;
  }
});
Object.defineProperty(exports, "ValidateBirthdate", {
  enumerable: true,
  get: function get() {
    return _ageHelpers.ValidateBirthdate;
  }
});
Object.defineProperty(exports, "getDaysSinceBirth", {
  enumerable: true,
  get: function get() {
    return _ageHelpers.getDaysSinceBirth;
  }
});
var _ageHelpers = require("./ageHelpers");
var _arrayHelpers = require("./arrayHelpers");
var _dataHelpers = require("./dataHelpers");
var _dateHelpers = require("./dateHelpers");
var _formatters = require("./formatters");
var _numberHelpers = require("./numberHelpers");
var _stringHelpers = require("./stringHelpers");
var _objectHelpers = require("./objectHelpers");
var _currencyHelpers = require("./currencyHelpers");